import { FC, useState, ChangeEvent, SyntheticEvent, useContext } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Tab, CircularProgress } from "@mui/material";
import TabContext from "@mui/lab/TabContext/TabContext";
import TabList from "@mui/lab/TabList/TabList";
import { tabsProp } from "../../common/interfaces/chart.interface";
import { TableFilterClub } from "../../common/enums/common.enums";
import { useTableClubContext } from "../../context/tabs/TableClubContext";
import { clubTableArr } from "../../common/constants/chart.constants";
import clubAvatar from "../../assets/clubAvatar.png";

interface IBasicTableProps {
  onSearch: (value: string) => void;
  items: any[];
  tabs: tabsProp[];
  columns?: any[];
  loader: boolean;
}

export const BasicTableWithTabs: FC<IBasicTableProps> = ({
  onSearch,
  items,
  columns,
  tabs,
  loader,
  ...other
}) => {
  const [search, setSearch] = useState<string>("");
  const [value, setValue] = useState(TableFilterClub.BALANCE);
  const { tab, changeTab } = useContext(useTableClubContext);

  const columnTitle = Object.values(clubTableArr).find((t) => t.id === tab) || {
    title: "",
  };

  const onSearchInput = (event: ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
    onSearch(search);
  };
  const clearSearch = () => {
    setSearch("");
    onSearch("");
  };

  const handleChange = (event: SyntheticEvent, newValue: TableFilterClub) => {
    changeTab(newValue);

    setValue(newValue);
  };

  return (
    <TableContainer component={Paper}>
      <TabContext value={value}>
        <TabList
          onChange={handleChange}
          variant="scrollable"
          scrollButtons={false}
          allowScrollButtonsMobile
        >
          {tabs.map((child, index) => (
            <Tab label={child.title} value={child.id} key={index} />
          ))}
        </TabList>
      </TabContext>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell align="right">
              {/* <div
                style={{
                  display: "flex",
                }}
              >
                <InputBase
                  placeholder="Search"
                  value={search}
                  inputProps={{ "aria-label": "search" }}
                  onChange={onSearchInput}
                />
                {search ? (
                  <IconButton
                    color="primary"
                    aria-label="clear search"
                    onClick={clearSearch}
                  >
                    <ClearIcon />
                  </IconButton>
                ) : (
                  <IconButton aria-label="clear search">
                    <SearchIcon />
                  </IconButton>
                )}
              </div> */}
            </TableCell>
            <TableCell align="right">{columnTitle.title}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody
          sx={{
            position: "relative",
            width: `${loader ? "500px" : "100%"}`,
            height: `${loader ? "300px" : "100%"}`,
          }}
        >
          {loader ? (
            <CircularProgress
              color="primary"
              sx={{
                marginTop: 1,
                position: "absolute",
                right: "50%",
                top: "50%",
              }}
            />
          ) : (
            items.map((row) => (
              <TableRow
                key={row.name}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={row?.imageUrl ? row?.imageUrl : clubAvatar}
                      style={{
                        borderRadius: "20px",
                        width: "50px",
                        height: "50px",
                        marginRight: "8px",
                      }}
                    />
                    {row.name}
                  </div>
                </TableCell>
                <TableCell align="right">{row.value}</TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
